import React, { useState, useEffect } from "react";
import { useStoreDispatch } from "../../../../store/hooks";
import { logout } from "../../../../store/api/auth/reducer";
import { useNavigate } from "react-router-dom";

const useGeneralData = () => {
    const navigate = useNavigate();
    const dispatch = useStoreDispatch();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => setWindowHeight(window.innerHeight);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const containerStyle = {
        height: windowHeight - 140,
        overflow: "auto",
        backgroundColor: "var(--card)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    };

    const cancelHandler = () => {
        dispatch(logout());
        navigate("/login");
    };

    return { containerStyle, cancelHandler };
}

export { useGeneralData };